import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    loadingContainer: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center"
    },
    container: {
        paddingTop: 0
    },
    userInitialInfoContainer: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row"
    },
    userInitialInfoAvatar: {
        flexDirection: "row",
        alignItems: "center"
    },
    paymentStatusContainer: {
        alignItems: "center",
        justifyContent: "space-between"
    },
    paymanetStatusTitle: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignContent: "space-between",
        alignItems: "center",
        width: "100%"
    },
    paymentStatusContentContainer: {
        flexDirection: "row"
    },
    paymenetStatusStatusCard: {
        alignSelf: "stretch",
        flex: 1
    },
    paymentStatusStatusBarContainer: {
        overflow: "hidden",
        width: "100%",
        minHeight: 8
    },
    paymentStatusStatusBarContent: {
        width: "75%",
        height: 8
    },
    paymentStatusStatusText: {
        alignSelf: "flex-end"
    },
    userCompaniesTitleContainer: {
        flexDirection: "row",
        justifyContent: "space-between"
    },
    userCompaniesActionButtons: {
        flexDirection: "row",
        alignContent: "center",
        alignItems: "center"
    },
    settingButton: {
    },
    listIconMid: {
    },
    listIconDanger: {
    },
    campaignImageWrapper: {
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center"
    },
    campaignImageRadius: {
        height: 200,
        width: "100%"
    },
    campaignTag: {
        position: "absolute"
    },
    campaignBottom: {
        position: "absolute"
    },
    actionButton: {
    },
    headerButton: {
        alignSelf: "flex-start"
    },
    profileAvatar: {
        width: 66,
        height: 66
    },
    companyLogo: {
        width: 50,
        height: 50
    },
    dialogHeader: {
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center"
    },
    dialogIconContainer: {
        alignSelf: "center"
    },
    textCenter: {
        textAlign: "center"
    },
    bottomSheet: {
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16
    },
    bottomSheetHeader: {
        alignItems: "center"
    },
    centerContent: {
        alignContent: "center",
        alignItems: "center"
    },
    logoWidth: {
        maxWidth: "60%"
    },
    successIconContainer: {
    },
    generalInfoContainer: {
    }
});
export default stylesheet;
